// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"dQ","checked":"dR","unchecked":"dS","darkTheme":"dT"};